import axios from 'axios';
import { ParamsBaseGet } from 'types/common';
import * as qs from 'qs';

export type BackgroundJobStatus = 'pending' | 'completed' | 'failed';

export type BackgroundJobItem = {
  id: string;
  type: string;
  userId: string;
  user?: { name: string; avatar?: string } | null;
  status: BackgroundJobStatus;
  createdAt: string;
  completedAt: string | null;
  failedAt: string | null;
};

export const adminGetBackgroundJobs = async (
  params: Partial<
    ParamsBaseGet & {
      type: string;
      userId: string;
      status: BackgroundJobStatus;
      dateFrom: string;
      dateTo: string;
    }
  >
) => {
  const query = qs.stringify({ ...params });
  const { data } = await axios.get(`/background-jobs?${query}`);
  return data as { success: boolean; total: number; page: number; data: BackgroundJobItem[] };
};
